import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Acabado, ColorMaterial, Continente, TipoMaterial, UsoMaterial, Stock, Espesor, Filter, FilterIdExtractor, Disponibilidad, RangoPrecio, CaracteristicaMaterial, Material } from '../models';

export const tipoMaterialAdapter: EntityAdapter<TipoMaterial> = createEntityAdapter({
  selectId: tpo => tpo.TIPOMATERIALID
})

export const acabadoAdapter: EntityAdapter<Acabado> = createEntityAdapter({
  selectId: acbo => acbo.CODIGO
})

export const usoMaterialAdapter: EntityAdapter<UsoMaterial> = createEntityAdapter({
  selectId : uso => uso.USOMATERIALID
})

export const continenteAdapter: EntityAdapter<Continente> = createEntityAdapter({
  selectId : ctn => ctn.CONTINENTEID
})

export const colorMaterialAdapter: EntityAdapter<ColorMaterial> = createEntityAdapter({
  selectId : clr => clr.COLORMATERIALID
})

export const espesorAdapter: EntityAdapter<Espesor> = createEntityAdapter({
  selectId: spsr => spsr.CODIGO
})

export const filterAdapter: EntityAdapter<Filter> = createEntityAdapter({
  selectId: FilterIdExtractor
})

export const disponibilidadAdapter: EntityAdapter<Disponibilidad> = createEntityAdapter({
  selectId: dis => dis.CODIGO
})

export const rangoPrecioAdapter: EntityAdapter<RangoPrecio> = createEntityAdapter({
  selectId: rng => rng.CODIGO
})

export const materialAdapater: EntityAdapter<Material> = createEntityAdapter({
  selectId: mat => mat.CODIGO
})

export const caracteristicasMaterialAdapater: EntityAdapter<CaracteristicaMaterial> = createEntityAdapter({
  selectId: car => car.CARACTERISTICAMATERIALID
})

export const materialSimilarAdapater: EntityAdapter<Material> = createEntityAdapter({
  selectId: mat => mat.CODIGO
})

export const stockAdapter: EntityAdapter<Stock> = createEntityAdapter({
  selectId: stk => stk.ID
})

